import { Type } from "class-transformer";
import { DriveItemDTO } from "./item";
import { IsBoolean, IsObject, IsOptional, IsString } from "class-validator";

export class DriveMoveToInputDTO {
	@IsString()
	folderID: string;

	@IsString()
	itemID: string;
}

export class DriveMoveToOutDTO {
	@IsBoolean()
	success: boolean;

	@IsOptional()
	@Type(() => DriveItemDTO)
	item?: DriveItemDTO
}
